// Module
var code = `<div tabindex="-1" class="js-win detached" {{>windowPart}} on-mousedown="@this.onMouseDown(event)" on-mousemove="@this.onMouseMove(event)" on-contextmenu="@this.onContextMenuOpen(event)" on-keydown="@this.onKeyDown(event)" on-mouseenter="@this.onMouseEnter(event)" on-mouseleave="@this.onMouseLeave(event)" >
    <div class="js-win-tabBar-tab {{.style_addition_header}}" on-dblclick="onHeaderDblClick" on-mousedown="@this.onMouseDown(event,true)">
        <div class="js-text">{{{.headerInnerHTML}}}</div>

        <div class="js-win-tabBar-button-sector">
            <terceraButton name="closeCrossBtn" SVG="true" terceraButtonStyle="js-closeWindowBtn" visible="{{.closeBtnVisible}}" />
        </div>
    </div>

    <div class="js-win-innerContainer {{.style_addition_body}}" style="{{#.showOverflow}}overflow:visible;{{/}}">
        <panelsContainerControl forcedSelectedPanel="{{forcedSelectedPanel}}">
            <terceraClosePositionScreen 
                                        position="{{position}}" 
                                        placedFrom="{{placedFrom}}" 
                                        activateNumericLinkName="{{activateNumericLinkName}}"
                                        on-onFillByPosition="@this.onChildFillByPosition(false)"/>
            <modifyPositionScreen 
                                position="{{position}}"
                                placedFrom="{{placedFrom}}"
                                activateNumericLinkName="{{activateNumericLinkName}}"
                                on-onFillByPosition="@this.onChildFillByPosition(true)"/>
        </panelsContainerControl>
    </div>
</div>

{{#partial windowPart}}
{{#if !(.dockablePanel)}}{{#.focused}}focused=""{{/}}{{/if}}
style="position: absolute;
{{#.withOutBorder}} border:0px solid transparent; {{/}}
{{#if .dockablePanel}}
{{#.width}}width:{{.width}}px;{{/}}
{{#.height}}height:{{.height}}px;{{/}}
{{#.bottom}}bottom:{{.bottom}}px;{{/}}
{{#.right}}right:{{.right}}px;{{/}}
{{^.visible}}display:none;{{/}}
border:0px solid transparent;
{{else}}
{{>position}}
{{/if}}
{{#if .showFullscreenCloud || .showModalMask}}
z-index:10000;
{{elseif .isLookup}}
z-index:1400;
{{elseif !(.dockablePanel) && .zIndex}}
z-index:{{.zIndex}};
{{elseif .showCustomFullscreenCloud && .zIndex}}
z-index:{{.zIndex}};
{{/if}}
{{#if .alwaysMiddle}}{{>alwaysMiddlePart}}{{/if}}"
showHeader="{{.showHeader?'1':0}}"
showFooter="{{.showFooter?'1':'0'}}"
showBorder="{{.showBorder?'1':'0'}}"
inDock="{{.dockablePanel?'1':'0'}}"
{{^.resizable}}noResize="1"{{/}}
{{/partial}}`;
// Exports
export default code;